namespace GeniuzPOS.Product {
    export interface PluDtForm {
        IsActive: Serenity.BooleanEditor;
        ActiveSellFg: Serenity.BooleanEditor;
        ActiveRepFg: Serenity.BooleanEditor;
        SkuCode: Serenity.LookupEditor;
        PluCode: Serenity.StringEditor;
        PluShortDesc: Serenity.StringEditor;
        PluDesc: Serenity.TextAreaEditor;
        StyleId: Serenity.LookupEditor;
        ColorId: Serenity.LookupEditor;
        SizeId: Serenity.LookupEditor;
        TasteId: Serenity.LookupEditor;
        MatTypeId: Serenity.LookupEditor;
        ConceptCode: Serenity.LookupEditor;
        SellUnit: Serenity.LookupEditor;
        SellUnitRatio: Serenity.DecimalEditor;
        DeliverCost: Serenity.DecimalEditor;
        PluType: Serenity.RadioButtonEditor;
        SellUnitPrice1: Serenity.DecimalEditor;
        SellUnitPrice2: Serenity.DecimalEditor;
        SellUnitPrice3: Serenity.DecimalEditor;
        SellUnitPrice4: Serenity.DecimalEditor;
        SellUnitPrice5: Serenity.DecimalEditor;
        SellUnitPrice6: Serenity.DecimalEditor;
    }

    export class PluDtForm extends Serenity.PrefixedContext {
        static formKey = 'Product.PluDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PluDtForm.init)  {
                PluDtForm.init = true;

                var s = Serenity;
                var w0 = s.BooleanEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.RadioButtonEditor;

                Q.initFormType(PluDtForm, [
                    'IsActive', w0,
                    'ActiveSellFg', w0,
                    'ActiveRepFg', w0,
                    'SkuCode', w1,
                    'PluCode', w2,
                    'PluShortDesc', w2,
                    'PluDesc', w3,
                    'StyleId', w1,
                    'ColorId', w1,
                    'SizeId', w1,
                    'TasteId', w1,
                    'MatTypeId', w1,
                    'ConceptCode', w1,
                    'SellUnit', w1,
                    'SellUnitRatio', w4,
                    'DeliverCost', w4,
                    'PluType', w5,
                    'SellUnitPrice1', w4,
                    'SellUnitPrice2', w4,
                    'SellUnitPrice3', w4,
                    'SellUnitPrice4', w4,
                    'SellUnitPrice5', w4,
                    'SellUnitPrice6', w4
                ]);
            }
        }
    }
}
